import React, {Component} from 'react';
import axios from "axios";
import Workflow from "../core/Workflow";
import AuthService from "../../AuthService";


class SettingsDialog extends Component {
    constructor(props) {
        super(props);

        this.wowkflow = React.createRef();

        this.state = {
            workflowInitData : {
                WORKFLOW_ID: this.props.workflowId,
                PARAM_rootId: this.props.rootId
            },
            rootId: this.props.rootId,
            path: this.props.path
        }

        this.coreChange = this.coreChange.bind(this);
        this.coreSubmit = this.coreSubmit.bind(this);
        this.coreExternalCall = this.coreExternalCall.bind(this);
    }

    coreChange(e) {

    }

    async coreExternalCall(method) {
    	await axios.post(AuthService.getUrl('/' + method), {id: this.state.rootId}, AuthService.getAuthHeader()).then(
    		res => {
    			document.location = this.state.path;
            }
        );
    }

    coreSubmit(data) {
    }

    render() {
        return (
            <div className="responsiveForm">
                {!!(this.state.errorMessage) &&
                <div className="errorMessage">
                    <span>{this.state.errorMessage}</span>
                </div>
                }
                {!!(this.state.validMessage) &&
                <div className="actionMessage">
                    <span>{this.state.validMessage}</span>
                </div>
                }
                <Workflow   ref={this.wowkflow}
                            initData={this.state.workflowInitData}
                            onChange={this.coreChange}
                            onSubmit={this.coreSubmit}
                            externalCall={this.coreExternalCall}
                            primaryKey={this.state.rootId}/>
            </div>
        );
    }
}

export default SettingsDialog;
